import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore, collection, addDoc } from "firebase/firestore"; // Import Firestore
import { getAuth } from "firebase/auth"; // Import Auth


const firebaseConfig = {
  apiKey: "AIzaSyBD15h9EE8pHpKnDW_DCgIJjdvHXJkKmWc",
  authDomain: "woaomwebdesign-19ef1.firebaseapp.com",
  projectId: "woaomwebdesign-19ef1",
  storageBucket: "woaomwebdesign-19ef1.firebasestorage.app",
  messagingSenderId: "618216884080",
  appId: "1:618216884080:web:177cbd9dae73c9346131b5",
  measurementId: "G-15K7SCEGLM"
};


// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore(app); // Initialize Firestore with the 'app' object
const auth = getAuth(app); // Initialize Auth with the 'app' object

export { db, auth, analytics, collection, addDoc };